import { Stack } from "@mui/material"
import { ReactElement, useContext } from "react"

import CreateEvacDeviceProgressStepper from "./components/createEVACDeviceProgressStepper"
import CoreEVACDeviceDetails from "./formPages/coreEVACDeviceDetails"
import EVACManufacturer from "./formPages/EVACmanufacturer"
import ReviewAndSubmitEVACDevice from "./formPages/reviewAndSubmitEVACDevice"
import { CreateEVACDeviceContext } from "./providers/baseProviders/createEVACDeviceProvider"
import { Datasets } from "../../../../constants/enums"
import { GRID_SPACING } from "../../../../themes/defaultThemeParams"
import MultiPageForm from "../../../multiPageForm/multiPageForm"
import { AppCard, AppCardContent } from "../../../surfaces/appCard"
import LctDeviceAttachments from "../../common/components/attachments/lctDeviceAttachments"
import { EVACDeviceFormData } from "../types/providerTypes"

/** The form for creating an EVAC device */
const CreateEVACDeviceForm = (): ReactElement => {
    const { canEditManufacturer } = useContext(CreateEVACDeviceContext)

    return (
        <Stack spacing={GRID_SPACING}>
            <AppCard>
                <AppCardContent>
                    <CreateEvacDeviceProgressStepper />
                </AppCardContent>
            </AppCard>

            <MultiPageForm context={CreateEVACDeviceContext}>
                {canEditManufacturer && (
                    <EVACManufacturer context={CreateEVACDeviceContext} />
                )}
                <CoreEVACDeviceDetails context={CreateEVACDeviceContext} />
                <LctDeviceAttachments<EVACDeviceFormData>
                    context={CreateEVACDeviceContext}
                    dataset={Datasets.EVAC}
                    isAmendment={false}
                />
                <ReviewAndSubmitEVACDevice
                    context={CreateEVACDeviceContext}
                    isAmendment={false}
                />
            </MultiPageForm>
        </Stack>
    )
}

export default CreateEVACDeviceForm
